import React from 'react'
import { Link } from 'react-router-dom'

interface IProps {
  className?: string
  children?: React.ReactNode | string
  count?: number
  active?: boolean
  to?: any
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  alwaysShowCount?: false
}

function Tab(props: IProps): React.ReactElement {
  const Tag = props.to ? Link : 'a'

  return (
    <Tag
      to={props.to}
      role={!props.to ? 'button' : undefined}
      className={`tab ${props.active ? '_active' : ''} ${
        props.className ?? ''
      }`.trim()}
      onClick={props.onClick}
    >
      <span className="tab__inner">{props.children}</span>
      {(typeof props.count === 'number' && props.count > 0) ||
      props.alwaysShowCount ? (
        <span className={'tab__count'}>
          {(props.count ?? 0) > 99 ? '99+' : props.count}
        </span>
      ) : null}
    </Tag>
  )
}

export default Tab
